import {getEventId} from '@wix/wix-events-commons-statics'
import {
  getLanguage,
  isMobile,
  isPreview,
  isPrimaryLanguage,
  isSite,
} from '../../../../../../commons/selectors/environment'
import {isCurrentUserLoggedIn} from '../../../selectors/current-user'
import {getEvent} from '../../../selectors/event'
import {isRequestPending} from '../../../selectors/pending-requests'
import {getReservationId} from '../../../selectors/reservation'
import {DetailsPageAppProps} from '../../app/interfaces'
import {connect} from '../../runtime-context/context'
import {PaymentOwnProps, PaymentRuntimeProps} from './interfaces'
import {Payment as PaymentPresentation} from './payment'

const mapRuntime = ({
  state,
  actions: {openCantCompletePaymentModal, navigateToOrder, navigateTo, expressCheckout, updatePaymentMethod},
  host,
}: DetailsPageAppProps): PaymentRuntimeProps => {
  const {instanceId, visitorId, msid, siteOwnerId, instance} = state.instance
  return {
    eventId: getEventId(getEvent(state)),
    order: state.placedOrder.order,
    reservationId: getReservationId(state),
    isMobile: isMobile(state),
    locale: getLanguage(state),
    isSite: isSite(state),
    isPreview: isPreview(state),
    primaryLanguage: isPrimaryLanguage(state),
    instanceId,
    visitorId,
    msid,
    siteOwnerId,
    openCantCompletePaymentModal,
    navigateToOrder,
    navigateTo,
    lang: state.multilingual?.currentLanguage,
    instance,
    siteStyles: host.style,
    isSignedInUser: isCurrentUserLoggedIn(state),
    updateLayout: host.updateLayout,
    expressCheckout,
    updatePaymentMethod,
    updateOrderInProgress: isRequestPending(state, 'UPDATE_ORDER_REQUEST'),
  }
}

export const Payment = connect<PaymentOwnProps, PaymentRuntimeProps>(mapRuntime)(PaymentPresentation)
